export const vaultConstants = {
  GET_VAULT_LIST_SUCCESS: 'GET_VAULT_LIST_SUCCESS',
  GET_VAULT_LIST_FAILURE: 'GET_VAULT_LIST_FAILURE'
};
